import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Droppable } from 'react-beautiful-dnd'
import { Draggable } from 'react-beautiful-dnd'
import KanbanCard from './KanbanCard'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import IconButton from '@mui/material/IconButton';
import 'react-virtualized/styles.css';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';

export default class KanbanColumn extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mouseIsHovering: false,
            isCollapsed: localStorage.getItem('filter_isCollapsed_' + this.props.id) === 'true',
            expandedProject: []
        };
        const cache = new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 210
        });
        this.cache = cache;

        this.handleCollapseClick = this.handleCollapseClick.bind(this);
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.generateGroup = this.generateGroup.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ mouseIsHovering: false });
    }

    handleExpandClick = projectId => evt => {
        var expandedProject = this.state.expandedProject.slice(0);
        var index = this.state.expandedProject.findIndex(p => p === projectId);
        if (index < 0) {
            expandedProject.push(projectId);
        }
        else {
            expandedProject.splice(index, 1);
        }
        this.setState({ expandedProject: expandedProject});
    }

    /*shouldComponentUpdate(nextProps, nextState) {
        console.log(this.props.works !== nextProps.works);
        return this.props.works !== nextProps.works;
    }*/

    sort(a, b) {
        var res = b.priorityOrder - a.priorityOrder;
        return res !== 0 ? res : ((b.loyaltyLevelOrder - a.loyaltyLevelOrder) !== 0 ? (b.loyaltyLevelOrder - a.loyaltyLevelOrder) : a.position - b.position);
    }

    generateKanbanCards() {
        return this.props.works.slice(0).sort(this.sort).map((work, index) => {
            return (
                <Draggable draggableId={work.id} index={index} key={work.id}>
                    {(provided, snapshot) => (
                        <KanbanCard
                            work={work}
                            key={work.id}
                            innerRef={provided.innerRef}
                            provided={provided}
                            isDragging={snapshot.isDragging}
                            snapshot={snapshot}
                            onDragEnd={this.props.onDragEnd}
                            onWorkUpdate={this.props.onWorkUpdate}
                            onCardOpen={this.props.onCardOpen}
                            onDragPositionChange={this.props.onDragPositionChange}
                            onCtrlCardClick={this.props.onCtrlCardClick}
                        />)
                    }
                </Draggable>
            );
        });
    }

    handleCollapseClick() {
        var newValue = !this.state.isCollapsed;
        this.setState({ isCollapsed: newValue });
        localStorage.setItem('filter_isCollapsed_' + this.props.id, newValue);
    }

    generateVirtualKanbanCards = (works) => ({ index, parent, key, style }) => {
        if (works.length == 0) return;
        const work = works[index];
        return (
            <Draggable draggableId={work.id} index={index} key={work.id}>
                {(provided, snapshot) => (
                    <CellMeasurer
                        key={key}
                        cache={this.cache}
                        parent={parent}
                        columnIndex={0}
                        rowIndex={index}
                    >
                        <KanbanCard
                            work={work}
                            key={work.id}
                            innerRef={provided.innerRef}
                            provided={provided}
                            isDragging={snapshot.isDragging}
                            snapshot={snapshot}
                            onCardOpen={this.props.onCardOpen}
                            onCtrlCardClick={this.props.onCtrlCardClick}
                            style={{ ...style }}
                        />
                    </CellMeasurer>)
                }
            </Draggable>
        );
    }

    generateGroup(works, columnId, isExpanded) {
        var groups = Object.values(works.reduce(function (accumulator, objValue) {
            (accumulator[objValue.projectId] = accumulator[objValue.projectId] || []).push(objValue);
            return accumulator;
        }, {}));

        if (groups.length === 0 || !isExpanded) {
            return (<Droppable droppableId={columnId + '_project_'} type="TASK" mode="virtual"
                renderClone={(
                    provided,
                    snapshot,
                    rubric,
                ) => (
                        <KanbanCard
                            work={[]}
                            key={[]}
                            innerRef={provided.innerRef}
                            provided={provided}
                            isDragging={snapshot.isDragging}
                            snapshot={snapshot}
                            onCardOpen={this.props.onCardOpen}
                            onCtrlCardClick={this.props.onCtrlCardClick}
                        />
                    )
                }
            >
                {(droppableProvided) => (
                    <List
                        height={10}
                        rowCount={0}
                        width={300}
                        style={{ "width": "calc(100wh/5)" }}
                        rowHeight={210}
                        ref={ref => {
                            if (ref) {
                                const whatHasMyLifeComeTo = ReactDOM.findDOMNode(ref);
                                if (whatHasMyLifeComeTo instanceof HTMLElement) {
                                    droppableProvided.innerRef(whatHasMyLifeComeTo);
                                }
                            }
                        }}
                        rowRenderer={this.generateVirtualKanbanCards([])}
                    />
                )}
            </Droppable>);
        }

        return groups.map(g =>
                <div className="work-project-group">
                {g.length > 0 &&
                    <>
                        <b>{g[0].projectName}({g.length})</b>
                        <IconButton
                            onClick={this.handleExpandClick(g[0].projectId + '_' + columnId)}
                            size="large">
                            {this.state.expandedProject.findIndex(p => p === g[0].projectId + '_' + columnId) >= 0 && <ExpandLessIcon />}
                            {this.state.expandedProject.findIndex(p => p === g[0].projectId + '_' + columnId) < 0 && <ExpandMoreIcon />}
                       </IconButton>
                        <div>
                            <Droppable droppableId={columnId + '_project_' + g[0].projectId} type="TASK" mode="virtual"
                                renderClone={(
                                    provided,
                                    snapshot,
                                    rubric,
                                ) => (
                                        <KanbanCard
                                            work={g.sort(this.sort)[rubric.source.index]}
                                            key={g.sort(this.sort)[rubric.source.index].id}
                                            innerRef={provided.innerRef}
                                            provided={provided}
                                            isDragging={snapshot.isDragging}
                                            snapshot={snapshot}
                                            onCardOpen={this.props.onCardOpen}
                                            onCtrlCardClick={this.props.onCtrlCardClick}
                                        />
                                    )
                                }
                            >
                                {(droppableProvided) => (
                                    <List
                                        height={this.state.expandedProject.findIndex(p => p === g[0].projectId + '_' + columnId) < 0 ? 10 : (210 * g.length + 50)}
                                        rowCount={g.length}
                                        width={300}
                                        style={{ "width": "calc(100wh/5)" }}
                                        rowHeight={210}
                                        ref={ref => {
                                            if (ref) {
                                                const whatHasMyLifeComeTo = ReactDOM.findDOMNode(ref);
                                                if (whatHasMyLifeComeTo instanceof HTMLElement) {
                                                    droppableProvided.innerRef(whatHasMyLifeComeTo);
                                                }
                                            }
                                        }}
                                        rowRenderer={this.generateVirtualKanbanCards(((this.props.isCollapseColumn && this.state.isCollapsed) || this.state.expandedProject.findIndex(p => p === g[0].projectId + '_' + columnId) < 0) ? [] : g.sort(this.sort))}
                                    />
                                )}
                            </Droppable>
                        </div>
                    </>}
                </div>
            );
    }

    render() {
        //console.log("render column " + this.props.id);
        return (
            <div className={"droppable-column " + ((this.props.isCollapseColumn && this.state.isCollapsed) ? "collapsed-column" : "")}>
                {this.props.isGroupable && !this.state.isCollapsed && <div>
                    <div className="kanban-column" style={{"height": "90vh"}}>
                        <div className="clearfix" style={{ "display": "flex" }}><div className={"column-title column-" + this.props.id}>{this.props.name}</div>
                            <div className="column-counter">{this.props.works && this.props.works.length}</div>
                            {this.props.isCollapseColumn && <IconButton
                                onClick={this.handleCollapseClick}
                                style={{ "padding": "2px" }}
                                size="large">
                                {!this.state.isCollapsed && <ChevronLeftIcon />}
                                {this.state.isCollapsed && <ChevronRightIcon />}
                            </IconButton>}
                        </div>

                        {this.props.isMultiply &&
                            <>{this.props.id.map(id =>
                                <><div className="work-project-environment-group">
                                    <b>{id.caption}({this.props.works.filter(w => w.statusId === id.value).length})</b>
                                        <IconButton onClick={this.handleExpandClick(id)} size="large">
                                        {this.state.expandedProject.findIndex(p => p === id) >= 0 && <ExpandLessIcon />}
                                        {this.state.expandedProject.findIndex(p => p === id) < 0 && <ExpandMoreIcon />}
                                        </IconButton>
                                    {this.generateGroup(this.props.works.filter(w => w.statusId === id.value), id.value, this.state.expandedProject.findIndex(p => p === id) >= 0)}
                                </div>
                                <div className="work-project-environment-group-divider"/></>)
                            }</>
                        }

                        {!this.props.isMultiply && this.generateGroup(this.props.works, this.props.id)}
                    </div>
                </div>
                }
                {(!this.props.isGroupable || this.state.isCollapsed) && <Droppable droppableId={this.props.id} type="TASK" mode="virtual"
                    renderClone={(
                        provided,
                        snapshot,
                        rubric,
                    ) => (
                            <KanbanCard
                                work={this.props.works.sort(this.sort)[rubric.source.index]}
                                key={this.props.works.sort(this.sort)[rubric.source.index].id}
                                innerRef={provided.innerRef}
                                provided={provided}
                                isDragging={snapshot.isDragging}
                                snapshot={snapshot}
                                onCardOpen={this.props.onCardOpen}
                                onCtrlCardClick={this.props.onCtrlCardClick}
                            />
                        )
                    }
                >
                    {(droppableProvided) => (
                        <div className="kanban-column">
                            <div className="clearfix" style={{ "display": "flex" }}><div className={"column-title column-" + this.props.id}>{this.props.name}</div>
                                <div className="column-counter">{this.props.works && this.props.works.length}</div>
                                {this.props.isCollapseColumn && <IconButton
                                    onClick={this.handleCollapseClick}
                                    style={{ "padding": "2px" }}
                                    size="large">
                                    {!this.state.isCollapsed && <ChevronLeftIcon />}
                                    {this.state.isCollapsed && <ChevronRightIcon />}
                                </IconButton>}
                            </div>
                            <AutoSizer disableWidth>
                                {({ height }) => (
                                    <List

                                        height={height}
                                        rowCount={this.props.works.length}
                                        width={300}
                                        style={{ "width": "calc(100wh/5)" }}
                                        rowHeight={210}
                                        ref={ref => {
                                            // react-virtualized has no way to get the list's ref that I can so
                                            // So we use the `ReactDOM.findDOMNode(ref)` escape hatch to get the ref
                                            if (ref) {
                                                // eslint-disable-next-line react/no-find-dom-node
                                                const whatHasMyLifeComeTo = ReactDOM.findDOMNode(ref);
                                                if (whatHasMyLifeComeTo instanceof HTMLElement) {
                                                    droppableProvided.innerRef(whatHasMyLifeComeTo);
                                                }
                                            }
                                        }}
                                        rowRenderer={this.generateVirtualKanbanCards(this.props.isCollapseColumn && this.state.isCollapsed ? [] : this.props.works.sort(this.sort))}
                                    />)}
                            </AutoSizer>
                        </div>

                    )}
                </Droppable>}
            </div>
        );
    }
}